import { render, staticRenderFns } from "./ShotsForm.vue?vue&type=template&id=2108c498&scoped=true&"
import script from "./ShotsForm.vue?vue&type=script&lang=js&"
export * from "./ShotsForm.vue?vue&type=script&lang=js&"
import style0 from "./ShotsForm.vue?vue&type=style&index=0&id=2108c498&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108c498",
  null
  
)

export default component.exports